/**
 * Utility functions for the website
 */

/**
 * Get the full image URL by prepending the API URL if needed
 * Handles both relative paths (/uploads/...) and full URLs (https://...)
 */
export function getImageUrl(imagePath: string | undefined): string {
  if (!imagePath) return '';

  // If it's already a full URL (starts with http:// or https://), return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Otherwise, prepend the API URL
  const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001';

  // Ensure no double slashes
  const cleanApiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;

  return `${cleanApiUrl}${cleanPath}`;
}

/**
 * Format price in Israeli Shekel (₪)
 */
export function formatPrice(price: number): string {
  return `₪${price.toFixed(2)}`;
}

/**
 * Format date in Hebrew locale
 */
export function formatDate(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('he-IL');
}

/**
 * Format datetime in Hebrew locale
 */
export function formatDateTime(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleString('he-IL');
}
